/** Square framing everywhere customer-facing logos appear (cover-fit). */
export const BUSINESS_LOGO_CROP_ASPECT = 1;

/** Exported image size — enough detail for retina cards without huge uploads. */
export const BUSINESS_LOGO_OUTPUT_PX = 512;

/** Human-readable hints for the crop UI */
export const BUSINESS_LOGO_DISPLAY_HINT =
  'Your logo is shown as a square across NKY Connect — on your dashboard header (about 160×160 pixels), provider listings (about 120×120), and service cards (smaller thumbnails). Drag and zoom until it looks right in the square preview.';
